import React from 'react';
import { assets, business, mailtoHref, mapsHref, navLinks } from '../data/content';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="w-full border-t-4 border-ink bg-white" data-id="element-62" data-mp="3gh3rcermy6f5">
      <div className="mx-auto max-w-shell px-5 py-12 lg:px-8 lg:py-14" data-id="element-63" data-mp="32p5qssbzpiul">
        <div className="grid grid-cols-1 gap-9 sm:grid-cols-2 lg:grid-cols-[1.1fr_0.65fr_0.95fr_1.3fr] lg:gap-6" data-id="element-64" data-mp="36oo8zgcffftq">
          <div data-id="element-65" data-mp="3ug3bpa847z5i">
            <img src={assets.logo} alt="South Lyon Fence" width={184} height={83} loading="lazy" className="h-[76px] w-auto" data-id="element-66" data-mp="3ufjuxwu7bgt2" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-steel" data-id="element-67" data-mp="3lgopimyzeaqt">
              Utility and commercial fencing, gates and specialty perimeter protection. Serving
              since {business.since}.
            </p>
          </div>

          <nav aria-label="Footer" className="border-t border-steel-100 pt-6 sm:border-t-0 sm:pt-0 lg:border-l lg:pl-6" data-id="element-68" data-mp="2eyjq5m4bf0um">
            <h2 className="border-b-2 border-safety pb-3 font-display text-[20px] font-semibold uppercase tracking-[0.08em] text-ink" data-id="element-69" data-mp="3labqttpu02pb">
              Explore
            </h2>
            <ul className="mt-3 text-[15px] text-ink" data-id="element-70" data-mp="3v7zwvfsw0wms">
              {navLinks.map(link => <li key={link.href} data-id="element-71" data-mp="3q8dk17gz1iei">
                  <a href={link.href} className="inline-flex min-h-[44px] items-center transition-colors duration-150 ease-industrial hover:text-steel lg:min-h-[36px]" data-id="element-72" data-mp="3q7bw42eux1fd">
                    {link.label}
                  </a>
                </li>)}
              <li data-id="element-73" data-mp="huo533x2gtuk">
                <a href="#contact" className="inline-flex min-h-[44px] items-center transition-colors duration-150 ease-industrial hover:text-steel lg:min-h-[36px]" data-id="element-74" data-mp="cu0fmmohkl2g">
                  Contact
                </a>
              </li>
            </ul>
          </nav>

          <div className="border-t border-steel-100 pt-6 sm:border-t-0 sm:pt-0 lg:border-l lg:pl-6" data-id="element-75" data-mp="tvmp5eeoaakb">
            <h2 className="border-b-2 border-safety pb-3 font-display text-[20px] font-semibold uppercase tracking-[0.08em] text-ink" data-id="element-76" data-mp="ytehuan560pk">
              Location
            </h2>
            <a href={mapsHref} target="_blank" rel="noopener noreferrer" className="mt-4 block text-[15px] leading-relaxed text-ink transition-colors duration-150 ease-industrial hover:text-steel" data-id="element-77" data-mp="18k0rzpc39z0v">
              {business.address.street}
              <br data-id="element-78" data-mp="1mk1sv4sct6gc" />
              {business.address.city}, {business.address.state} {business.address.zip}
            </a>
            <p className="mt-3 text-sm text-steel" data-id="element-79" data-mp="1rj4v6hgy8ykm">{business.states.join(' \u2022 ')}</p>
          </div>

          <div className="min-w-0 border-t border-steel-100 pt-6 sm:border-t-0 sm:pt-0 lg:border-l lg:pl-6" data-id="element-80" data-mp="3oc6q8vsmgvyg">
            <h2 className="border-b-2 border-safety pb-3 font-display text-[20px] font-semibold uppercase tracking-[0.08em] text-ink" data-id="element-81" data-mp="3tb1a812bsqk5">
              Contact
            </h2>
            <ul className="mt-3 text-[15px] text-ink" data-id="element-82" data-mp="25o59chqqnpc5">
              <li data-id="element-83" data-mp="25mao12bk1v7j">
                <a href={business.phoneHref} className="inline-flex min-h-[44px] items-center transition-colors duration-150 ease-industrial hover:text-steel" data-id="element-84" data-mp="21mtjcb3yd23f">
                  {business.phone}
                </a>
              </li>
              <li data-id="element-85" data-mp="2tbn4mn97p5jv">
                <a href={business.tollFreeHref} className="inline-flex min-h-[44px] items-center transition-colors duration-150 ease-industrial hover:text-steel" data-id="element-86" data-mp="2pcnu8n4pogl1">
                  {business.tollFree} <span className="ml-1 text-steel" data-id="element-87" data-mp="2fdf30218dg2d">(toll free)</span>
                </a>
              </li>
              <li data-id="element-88" data-mp="18zpjslnmpfz1">
                <a href={mailtoHref} className="inline-flex min-h-[44px] max-w-full items-center break-words text-[14px] transition-colors duration-150 ease-industrial hover:text-steel lg:whitespace-nowrap" data-id="element-89" data-mp="18w1mrciz6bfk">
                  {business.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <p className="mt-9 border-t border-steel-100 pt-5 text-sm text-steel" data-id="element-90" data-mp="2iwma0bzgr14r">
          &copy; {year} {business.name}
        </p>
      </div>
    </footer>;
}